export default __webpack_public_path__ + "static/media/placeholder_private03-fr-mobile.64581d2e.png";